<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
          lg="12"
          style="display:block; text-align:center;padding-bottom:15px;font-size:1.2em;"
          v-if="total>0" >
        <span style="padding:5px;">Total Records:</span>
        <b style="padding-right:5px;">{{total}}</b>
        <b-button
            class="download-button"
            variant="primary"
            size="lg"
            @click="downloadExcel();"
        >

          <div style="display:inline-block;" v-if="loading2019" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce bouncing2">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>

          <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
          Download
        </b-button>




      </b-col>
      <b-col lg="12">
        <c-table :table-data="data" :fields="fields" :caption="title"  ></c-table>
        <div v-show="loading" class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </b-col>

    </b-row>
  </div>
</template>

<script>
import cTable from "./Table.vue";

export default {
  props: [
    "location",
    "productGroup",
    "type",
    "date_from",
    "date_to",
    "productModel",
    "prg",
    "clients",
    "failure",
    "fns_part",
    "MAC_ADDR_HIT",
    "client",
    "client_address"
  ],
  name: "TableRMA",
  components: { cTable },
  data: () => {
    return {
      locationParam: "",
      excelDownload: "",
      loading2019: false,
      loadingExcel: false,
      clientsId: "",
      productGroupParam: "",
      dateFromParam: "",
      modelParam: "",
      dateToParam: "",
      title: "",
      loading: true,
      data: [],
      total: 0,
      totalPrice: 0,
      fields: [
        { key: "date", label: "Date", sortable: true },
        { key: "product_make", label: "Manufacturer" },
        { key: "product_model", label: "Product Model" },
        { key: "product_serial", label: "Serial Number" },
        { key: "MAC_ADDR_HIT", label: "MAC Address" },
        { key: "RMA_number", label: "RMA", sortable: true },
        { key: "client", label: "Customer" },
        { key: "client_address", label: "Address" },
      ],
    };
  },
  methods: {
    downloadExcel() {
      this.loading2019 = true;
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        xml: "true",
      };
      this.$http
          .get(this.excelDownload, {
            params,
            responseType: "blob"
          })
          .then(
              res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "TableReport.xlsx");
                document.body.appendChild(link);
                link.click();
                this.loading2019 = false;
              },
              err => {
                this.loading2019 = false;
                console.log(err);
              }
          );
    },
    fetchOpenRMA() {
      this.$http
          .get("api/hit/tables/activeOpenRMA.php")
          .then(
              res => {
                this.data = res.data.records;
                console.log(res.data);
                this.total = res.data.records.length;
                res.data.records.forEach(obj => {
                  if (obj.price != undefined) {
                    this.totalPrice =
                        this.totalPrice + parseFloat(obj.price.replace("$", ""));
                  }
                });
                this.loading = false;
              },
              err => {
                console.log(err);
              }
          );
    },fetchClosedRMA() {
      this.$http
          .get("api/hit/tables/closedRMA.php")
          .then(
              res => {
                this.data = res.data.records;
                console.log(res.data);
                this.total = res.data.records.length;
                res.data.records.forEach(obj => {
                  if (obj.price != undefined) {
                    this.totalPrice =
                        this.totalPrice + parseFloat(obj.price.replace("$", ""));
                  }
                });
                this.loading = false;
              },
              err => {
                console.log(err);
              }
          );
    },
    checkRma(){
      if (this.type === "openRMA") {
        this.title= "Active Open RMA's"
        this.fetchOpenRMA();
        this.excelDownload = "api/hit/tables/activeOpenRMA.php";
      }
      if (this.type === "closedRMA") {
        this.title= "Closed RMA's"
        this.fetchClosedRMA();
        this.excelDownload = "api/hit/tables/closedRMA.php";
      }
    }
  },
  watch: {
    type: function () {
      this.checkRma();
    }
  },
  mounted() {
    this.checkRma();
  }
};
</script>
<style>
.complaintClass {
  width: 200px;
}
.download-button {
  display: inline-block;
  margin: auto;
  float: right;
  font-weight: 500;
  padding: 0.7em;
  font-size: 0.9em;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
}
.bouncing2 {
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}
.download-button:hover {
  text-decoration: none !important;
  color: white;
}
.fa-file-excel-o {
  font-size: 1em;
  color: #ffffff68;
  transform: rotate(30deg);
  padding-right: 0.5em;
}
</style>
